import React, { FC, ReactNode } from 'react';

import bridgeIcon from '@assets/vaults/menu/bridge.svg?url';
import chartIcon from '@assets/vaults/menu/chart.svg?url';
import daoIcon from '@assets/vaults/menu/dao.svg?url';
import dexfiAiIcon from '@assets/vaults/menu/dexfi-ai.svg?url';
import docsIcon from '@assets/vaults/menu/documentation.svg?url';
import educationIcon from '@assets/vaults/menu/education.svg?url';
import eftsIcon from '@assets/vaults/menu/etfs.svg?url';
import gdexIcon from '@assets/vaults/menu/gdex.svg?url';
import positionIcon from '@assets/vaults/menu/position.svg?url';
import profitIcon from '@assets/vaults/menu/profits.svg?url';
import savedIcon from '@assets/vaults/menu/saved.svg?url';
import seedIcon from '@assets/vaults/menu/seed.svg?url';
import seedsIcon from '@assets/vaults/menu/seeds.svg?url';
import settingsIcon from '@assets/vaults/menu/settings.svg?url';
import spotIcon from '@assets/vaults/menu/spot.svg?url';
import usdexIcon from '@assets/vaults/menu/usdex.svg?url';
import userIcon from '@assets/vaults/menu/user.svg?url';
import viewAllIcon from '@assets/vaults/menu/view-all.svg?url';

import VaultsSubmenu from '@components/common/Layout/Header/HeaderContainer/VaultsSubmenu';

// import VaultsSubmenu from '@components/common/Layout/Header/HeaderContainer/VaultsSubmenu';

import {
  DiscordIconHeader,
  MediumIconHeader,
  TelegramIconHeader,
  TwitterIconHeader,
  YoutubeIconHeader,
} from '@constants/common/icons.constants';
import {
  DISCORD_LINK,
  MEDIUM_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
  YOUTUBE_LINK,
} from '@constants/common/links.constants';

import { VaultsFilterTab, VaultsTypeTab } from '../vaults/common.constants';
import { STRATEGY_FARM_PARAM, TAB_PARAM } from '../vaults/params.constants';
import {
  PATH_BRIDGE,
  PATH_CREATE_VAULT,
  PATH_DEXFI_AI,
  PATH_DEXSWAP_DOCUMENTATION,
  PATH_DEXVAULTS_DOCS,
  PATH_DEX_ADD,
  PATH_DEX_DAO,
  PATH_DEX_ETF,
  PATH_DEX_LIQUIDITY,
  PATH_DEX_LIQUIDITY_ADD,
  PATH_DEX_POOL_FIND,
  PATH_DEX_SWAP,
  PATH_DOCS,
  PATH_GDEX,
  PATH_LEADERBOARD,
  PATH_REQUEST_FARM,
  PATH_USDEX,
  PATH_VAULTS,
} from './routes.constants';

type HeaderMenuItem = {
  title: string;
  href: string;
  isDisable: boolean;
  newTab?: boolean;
  icon?: ReactNode;
  submenu?: FC<{ onClose: () => void }> | undefined;
  isBlueIcon?: boolean;
};

export const HEADER_ROUTES: HeaderMenuItem[] = [
  {
    title: 'Vaults',
    href: PATH_VAULTS,
    isDisable: false,
    // submenu: VaultsSubmenu,
  },
  {
    title: 'ETFs',
    href: PATH_DEX_ETF,
    isDisable: false,
  },
  // {
  //   title: 'Futures',
  //   href: PATH_PERPETUALS,
  //   isDisable: false,
  // },
  // {
  //   title: 'DAO',
  //   href: PATH_DEX_DAO,
  //   isDisable: false,
  //   newTab: true,
  // },
  {
    title: 'gDEX',
    href: PATH_GDEX,
    isDisable: false,
  },
  {
    title: 'USDEX+',
    href: PATH_USDEX,
    isDisable: false,
  },
  // {
  //   title: 'Spot',
  //   href: 'https://legacy.dexfi.com/swap',
  //   isDisable: false,
  //   newTab: true,
  // },
  // {
  //   title: 'Bridge',
  //   href: PATH_BRIDGE,
  //   isDisable: false,
  // },
];

interface SocialItem {
  icon: ReactNode;
  link: string;
}

export const SOCIAL_MEDIA: SocialItem[] = [
  {
    icon: DiscordIconHeader,
    link: DISCORD_LINK,
  },
  {
    icon: TelegramIconHeader,
    link: TELEGRAM_LINK,
  },
  {
    icon: TwitterIconHeader,
    link: TWITTER_LINK,
  },
  {
    icon: YoutubeIconHeader,
    link: YOUTUBE_LINK,
  },
  {
    icon: MediumIconHeader,
    link: MEDIUM_LINK,
  },
];

export const RESOURCES_MOB: HeaderMenuItem[] = [
  {
    title: 'Documentation',
    href: PATH_DEXSWAP_DOCUMENTATION,
    isDisable: false,
    icon: <img src={docsIcon} alt="" />,
  },
  {
    title: 'DexFi.ai',
    href: PATH_DEXFI_AI,
    isDisable: false,
    icon: <img src={dexfiAiIcon} alt="" />,
  },
];

export const ROUTES_MOB: HeaderMenuItem[] = [
  {
    title: 'ETFs',
    href: PATH_DEX_ETF,
    isDisable: false,
    icon: <img src={eftsIcon} alt="" />,
  },
  // {
  //   title: 'Spot',
  //   href: 'https://legacy.dexfi.com/swap',
  //   isDisable: false,
  //   newTab: true,
  //   icon: <img src={spotIcon} alt="" />,
  // },
  {
    title: 'USDEX+',
    href: PATH_USDEX,
    isDisable: false,
    icon: <img src={usdexIcon} alt="" />,
  },
  {
    title: 'DAO',
    href: PATH_DEX_DAO,
    isDisable: false,
    icon: <img src={daoIcon} alt="" />,
  },
  {
    title: 'Bridge',
    href: PATH_BRIDGE,
    isDisable: false,
    icon: <img src={bridgeIcon} alt="" />,
    isBlueIcon: true,
  },
  {
    title: 'gDEX',
    href: PATH_GDEX,
    isDisable: false,
    icon: <img src={gdexIcon} alt="" />,
  },
];

export const QUICK_LINKS_HEADER = [
  {
    title: 'DexFi.ai',
    href: PATH_DEXFI_AI,
    newTab: true,
  },
  {
    title: 'Documentation',
    href: PATH_DOCS,
    newTab: true,
  },
];

type MobileSubMenuItem = {
  title: string;
  href: string;
  isComingSoon?: boolean;
  newTab?: boolean;
  icon?: ReactNode;
};

export const QUICK_FIND_VAULTS_LINKS: MobileSubMenuItem[] = [
  {
    title: 'Single farm vaults',
    href: `${PATH_VAULTS}?${STRATEGY_FARM_PARAM}=${VaultsFilterTab.Single}`,
    icon: <img src={seedIcon} alt="" />,
  },
  {
    title: 'Multi-Farm Vaults',
    href: `${PATH_VAULTS}?${STRATEGY_FARM_PARAM}=${VaultsFilterTab.Strategy}`,
    icon: <img src={seedsIcon} alt="" />,
  },
  {
    title: 'View all',
    href: PATH_VAULTS,
    icon: <img src={viewAllIcon} alt="" />,
  },
];

export const TOOLS_VAULTS_LINKS: MobileSubMenuItem[] = [
  {
    title: 'Education',
    href: PATH_DEXVAULTS_DOCS,
    newTab: true,
  },
  {
    title: 'Leaderboard',
    href: PATH_LEADERBOARD,
  },
  {
    title: 'Request a farm',
    href: '/',
    isComingSoon: true,
  },
  {
    title: 'Create a vault',
    href: PATH_CREATE_VAULT,
  },
];

export const SUBMENU_ITEMS = [
  {
    subTitle: 'Find a vault',
    menu: QUICK_FIND_VAULTS_LINKS,
  },
  {
    subTitle: 'Tools',
    menu: TOOLS_VAULTS_LINKS,
  },
];

export const HIGHLIGHT_PATH_SPOT = [
  PATH_DEX_SWAP,
  PATH_DEX_LIQUIDITY,
  PATH_DEX_LIQUIDITY_ADD,
  PATH_DEX_POOL_FIND,
  PATH_DEX_ADD,
];

export const AVAILABLE_HEADER_SUB_ROUTES = [...HIGHLIGHT_PATH_SPOT];

export type STATUS = 'beginner' | 'intermediate' | 'expert';

type MenuFindVaultItem = {
  status?: STATUS;
  title: string;
  text: string;
  extraText?: string;
  isComingSoon?: boolean;
  icon: ReactNode;
  path?: string;
  newTab?: boolean;
};

export const FIND_A_VAULT_ITEMS: MenuFindVaultItem[] = [
  {
    status: 'beginner',
    title: 'Single Farm Vaults',
    text: 'Single farm vaults include only one farm and offer a variety of different take profit tokens and allocations.',
    icon: <img src={seedIcon} alt="" />,
    path: `${PATH_VAULTS}?${STRATEGY_FARM_PARAM}=${VaultsFilterTab.Single}`,
  },
  {
    status: 'expert',
    title: 'Multi-Farm Strategies',
    text: 'Strategies feature multiple farms within a single vault with allocations curated by the vault creator.',
    icon: <img src={seedsIcon} alt="" />,
    path: `${PATH_VAULTS}?${STRATEGY_FARM_PARAM}=${VaultsFilterTab.Strategy}`,
  },
  {
    status: 'expert',
    title: 'View all',
    text: 'View all single farm vaults along with multi-farm strategies in one place.',
    icon: <img src={viewAllIcon} alt="" />,
    path: PATH_VAULTS,
  },
];

export const TOOLS_ITEMS: MenuFindVaultItem[] = [
  {
    title: 'Education',
    text: 'Learn all about the ins and outs of the vaults.',
    icon: <img src={educationIcon} alt="" />,
    path: PATH_DEXVAULTS_DOCS,
    newTab: true,
  },
  {
    title: 'Leaderboard',
    text: 'Find the top investment options accross all chains.',
    icon: <img src={chartIcon} alt="" />,
    path: PATH_LEADERBOARD,
  },
  {
    title: 'Request a farm',
    text: 'Priority based on farm voting popularity.',
    icon: <img src={userIcon} alt="" />,
    path: PATH_REQUEST_FARM,
  },
  {
    title: 'Create a Vault',
    text: 'Mix and match multiple farm an a single strategy.',
    icon: <img src={settingsIcon} alt="" />,
    path: PATH_CREATE_VAULT,
  },
];

type MenuLearnItem = {
  title: string;
  icon: ReactNode;
  path?: string;
  onClick?: () => void;
};

export const QUICK_LINKS: MenuLearnItem[] = [
  {
    title: 'My Position',
    icon: <img src={positionIcon} alt="" />,
    path: `${PATH_VAULTS}?${TAB_PARAM}=${VaultsTypeTab.My}`,
  },
  {
    title: 'Saved Vaults',
    icon: <img src={savedIcon} alt="" />,
    path: `${PATH_VAULTS}?${TAB_PARAM}=${VaultsTypeTab.Saved}`,
  },
  {
    title: 'My Profits',
    icon: <img src={profitIcon} alt="" />,
    path: `${PATH_VAULTS}?${TAB_PARAM}=${VaultsTypeTab.Profit}`,
  },
];
